import React from 'react'
import { cx } from '@emotion/css'
import { oneOfType, arrayOf, node, string } from 'prop-types'
import LazyImage from '../LazyImage'

import Container from '../Container'

import styles from './styles'

const Navbar = ({ className, containerClassName, children }) => (
  <nav className={cx(styles.wrapper, className)}>
    <Container className={cx(styles.container, containerClassName)}>
      <a href="/" className={styles.logo} aria-label="Home">
        <LazyImage className={styles.logoImage} loader={() => import('../../assets/offerzen-logo.svg')} />
      </a>

      <div className={styles.navItems}>{children}</div>
    </Container>
  </nav>
)

Navbar.propTypes = {
  className: string,
  containerClassName: string,
  children: oneOfType([node, arrayOf(node)]),
}

export default Navbar
